/**
 * React subscription to the library version override lifecycle.
 * Mounting this hook anywhere also kicks off override loading, so the
 * status is populated on routes that don't render a wrapped library
 * component (e.g. the Dashboard).
 */

import { useEffect, useState } from 'react';

import {
  OVERRIDES_CHANGED_EVENT,
  ensureOverridesLoaded,
  getOverrideStatuses,
  hasOverrideRequests,
  type OverrideStatus,
} from '../utils/libVersionManager';

export const useOverrideStatuses = (): OverrideStatus[] => {
  const [statuses, setStatuses] = useState<OverrideStatus[]>(getOverrideStatuses());

  useEffect(() => {
    const update = (): void => setStatuses(getOverrideStatuses());
    window.addEventListener(OVERRIDES_CHANGED_EVENT, update);
    if (hasOverrideRequests()) void ensureOverridesLoaded().catch(() => undefined);
    update();
    return () => window.removeEventListener(OVERRIDES_CHANGED_EVENT, update);
  }, []);

  return statuses;
};
